import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import MUITextField from '@mui/material/TextField';
import MUIButton from '@mui/material/Button';
import {
  Submit as OriginalSubmit,
  Form as OriginalForm,
  PasswordField as OriginalPasswordField,
  DialogButton as OriginalDialogButton,
} from 'shared/containers/form';
import LabelledSelect from 'shared/components/LabelledSelect';

export const Root = styled.div`
  margin: 5%;
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px`}
  align-self: center;
`;

export const SectionTitle = styled(Typography).attrs({
  variant: 'h5',
})`
`;

const fieldAttrs = {
  autoComplete: 'off',
};

export const TextField = styled(MUITextField).attrs(fieldAttrs)`
`;

export const PasswordField = styled(OriginalPasswordField)`
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Footer = styled(Row)`
  margin-top: 20px;
  justify-content: space-around;
`;

export const Instructions = styled(Typography)`
  padding-top: 10px;
  padding-bottom: 20px;
`;

const buttonAttrs = {
  variant: 'contained',
};

export const Submit = styled(OriginalSubmit).attrs({
  ...buttonAttrs,
  color: 'primary',
})`
  align-self: center;
`;

export const Button = styled(MUIButton).attrs(buttonAttrs)`
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Form = styled(OriginalForm)`
  display: flex;
  flex-direction: column;
`;

export const DialogButton = styled(OriginalDialogButton).attrs({
  negativeButtonComponent: Button,
  positiveButtonComponent: Submit,
  formComponent: Form,
})`
`;

export const NarrowSelect = styled(LabelledSelect).attrs(fieldAttrs)`
  max-width: 150px;
`;